import { useEffect, useState } from "react";
import { useColor } from "react-color-palette";
import { SubmitErrorHandler, SubmitHandler } from "react-hook-form";
import { useParams } from "react-router-dom";
import adaptEditBrand from "../../adapters/adaptEditAppBrand";
import CreateAppBrandingForm from "../../containers/CreateAppBrandingForm/CreateAppBrandingForm";
import useAppBrand from "../../hooks/useAppBrand/useAppBrand";
import useEditAppBrand from "../../hooks/useEditAppBrand/useEditAppBrand";

const EditAppBranding = () => {
	const { brandId } = useParams<{ brandId: number }>();

	const [defaultValues, setDefaultValues] = useState<Partial<AppBrand>>({
		name: "",
		textColor: "",
		brandColor: ""
	});

	const { data } = useAppBrand(brandId);
	const { mutate: editAppBrand } = useEditAppBrand();

	useEffect(() => {
		if (!data) return;

		setDefaultValues(data);
	}, [data]);

	const handleValidSubmit: SubmitHandler<Partial<AppBrand>> = (data) => {
		console.log("FORM IS VALID", data);
		console.log(`EDIT BRAND, ID:${brandId}`, adaptEditBrand(data));

		editAppBrand(adaptEditBrand(data));
	};

	const handleInvalidSubmit: SubmitErrorHandler<Partial<AppBrand>> = (
		error
	) => {
		console.log("FAILED TO EDIT FORM", error);
	};

	return (
		<CreateAppBrandingForm
			defaultValues={defaultValues}
			onValidSubmit={handleValidSubmit}
			onInvalidSubmit={handleInvalidSubmit}
		/>
	);
};

export default EditAppBranding;
